
import { nodeHelpers } from '@/components/mixins/nodeHelpers';
import { showMessage } from '@/components/mixins/showMessage';
import BackgroundView from '@/components/BackgroundView.vue';
import Vue from 'vue';
import InteractionMenu from '@/components/InteractionMenu.vue';
import FilterBar from '@/components/FilterBar.vue';
import FilterIcon from '@/components/FilterIcon.vue';

import Table from '@/components/Table.vue';
import { genericHelpers } from '@/components/mixins/genericHelpers';
import { mapActions } from 'vuex';
import mixins from 'vue-typed-mixins';
import ModalButtonCancel from '@/components/ModalButtonCancel.vue';
import ModalButtonSuccess from '@/components/ModalButtonSuccess.vue';
import { NOTIFICATION_DETAILING_MODAL_KEY } from '../constants';

import AlertNotificationModal from '@/components/AlertNotificationModal.vue';

import { previousRoute } from '../router/index.ts';
import { notificationPermission } from '@/components/mixins/permissions/notifications';

import WebStorage from '@/common/WebStorage';

export default mixins(
	nodeHelpers,
	showMessage,
	notificationPermission,
	genericHelpers,
).extend({
	components: {
		BackgroundView,
		InteractionMenu,
		Table,
		FilterIcon,
		ModalButtonCancel,
		FilterBar,
		ModalButtonSuccess,
		AlertNotificationModal,
	},
	data() {
		return {
            NOTIFICATION_DETAILING_MODAL_KEY,
			clearFilteringActive: false,
			filtersActive: {},
			previousRoute: previousRoute,
			interactionMenu__link: 'createNotification',
			numPicture: 3,
			componentKey: 0,
			maxheight: '60vh',
			interactionMenu__titleHeader: 'Listagem de Notificações',
			interactionMenu__headerDropdownPlaceHolder:
				'credentials.interactionMenu__headerDropdownPlaceHolder',
			interactionMenu__headerPlaceHolderSearch:
				'credentials.interactionMenu__headerPlaceHolderSearch',
			interactionMenu__buttonToCleanFilter: 'credentials.interactionMenu__buttonToCleanFilter',

			tableTitle__1: 'credentials.tableTitle__credentials',
			tableTitle__2: 'Nome da Notificação',
			tableTitle__3: 'Canal de Notificação',
			tableTitle__4: 'Fluxos Vinculados',
			tableTitle__5: 'Resultados Selecionados',

			credentials__tableActionsButtonLeftDropdown:
				'credentials.credentials__tableActionsButtonLeftDropdown',
			credentials__tableActionsButtonLeftDropdownDelete:
				'credentials.credentials__tableActionsButtonLeftDropdownDelete',
			credentials__modalCreateTitle: 'credentials.credentials__modalCreateTitle',
			interactionMenu__buttonToRegisteredCredentials:
				'Nova Notificação',
			credentials__modalCreateAlert: 'credentials.credentials__modalCreateAlert',
			scrollInfinite: true,
			dataTable: [],
			filtering: false,
			numCells: '',
			page: 1,
			pageSize: 10,
			isLoadingTable: false,
			isLoadingPage: false,
			showAlert: false,

			applyedFilters: [],
			organizationInfo: '',
			excludeData: [],
			renderComponent: true,
			isLoadingAction: false,
		};
	},
	computed: {
		alertNotificationTitle() {
			return 'Deletar Notificação';
		},
		alertNotificationDescription() {
			return `Ao prosseguir o modelo de notificação será <b>excluído</b> e você <b>não poderá recuperá-lo</b>. O que você deseja fazer?`;
		},
		workspace() {
			return this.$store.getters.workspace;
		},
		textEmpty(){
			return this.filtering ? 'Não existe nenhum resultado com o(s) filtro(s) aplicado(s)! ' : 'Não há notificações cadastradas no momento. A medida que você adicionar novas notificações, as notificações serão apresentadas aqui.';
		},
	},
	async mounted() {
		this.$root.$on('reloadList', () => {
			this.getNotificationsList();
		});

		this.updateNumCells();
		this.$analytics.functionalityAccessed('Notificações');
		window.addEventListener('resize', this.updateNumCells);

	},
	async created() {
		this.isLoadingPage = true;
		this.organizationInfo = JSON.parse(WebStorage.getItem('organizationData'));
		await this.verifyPermissionUserAndInitiate();
		this.isLoadingPage = false;
	},
	methods: {
		...mapActions('auth', ['revokeTokens']),
		capitalize(str) {
			if (!str) return '';
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		},
		async forceRerender() {
			this.renderComponent = false;

			await Vue.nextTick();

			this.renderComponent = true;
        },
        openModalDetails(notificationId) {
			this.$store.dispatch('ui/openModalWithData', { modalKey: NOTIFICATION_DETAILING_MODAL_KEY, data: {notificationId} });
			this.$analytics.resourceManaged('Notificações', 'Abrir detalhamento');
        },

		limitedUsersShareFilter(listUsers) {
			return listUsers.slice(0, this.numPicture);
		},
		async verifyPermissionUserAndInitiate() {
			await this.validationAcessNotification().then(async () => {
				if (this.manageNotification) {
					await this.initPageNotifications();
				} else {
					this.$store.commit('setData403', {show: true, prevPage: previousRoute});
				}
			});
		},

		async filterBySearch(search) {
			this.filtering = search.length <= 2 ? true : false;
			this.addOrRemoveFilter(this.filtersActive, 'filterSearch', search.length <= 2 ? '' : search);
		},

		updateNumCells() {
			const windowWidth = window.innerWidth;
			const sideMenuSize = !this.isCollapsed ? 213 : 0;

			if (windowWidth >= 1900 + sideMenuSize ) {
				this.numCells = 19;
			} else if (windowWidth >= 1600 + sideMenuSize) {
				this.numCells = 15;
			}	else if (windowWidth >= 1360 + sideMenuSize) {
				this.numCells = 8;
			} else if (windowWidth >= 1060 + sideMenuSize) {
				this.numCells = 5;
			} else {
				this.numCells = 3;
			}
		},

		async filterTable(filters) {
			try {
				this.isLoadingTable = true;
				const routeQuery = this.$route.query;
				const payload = {
					size: 10,
					SearchNome: filters?.filterSearch || routeQuery?.searchNomeOuId,
				};

				this.$router.replace({query: { ...payload }}).catch(() => {});

				const dataFilter = await this.restApi().getNotifications(payload);
				await this.applyFilter(dataFilter, payload);
			} catch (e) {
				this.$store.commit('activeAlert', {
					message: e.notifications[0],
					status: 'error',
				});
			} finally {
				this.isLoadingTable = false;
			}
		},

		async applyFilter(dataFiltered, query) {
			this.page = 1;
			this.filtering = true;
			this.clearFilteringActive = true;
			this.scrollInfinite = true;
			this.dataTable = dataFiltered;
			this.$store.commit('setFilters', query);
		},

		async clearFilter() {
			this.page = 1;
			this.filtering = false;
			this.clearFilteringActive = false;
			this.filtersActive = {};
			this.scrollInfinite = true;
			this.componentKey ++;
			this.applyedFilters = [];

			await this.$router.replace({'query': null}).catch(() => {});

			this.initPageNotifications();
		},

		addOrRemoveFilter(object, property, value) {
			if ((Array.isArray(value) && value.length === 0) || value === '') {
				this.$delete(object, property);
			} else {
				this.$set(object, property, value);
			}
		},
		goToEditNotification(id) {
			this.$analytics.resourceManaged('Notificações', 'Editar');

			this.$router.push({
				name: 'editNotification',
				params: { id },
			});
		},

		openModalAlert(data) {
			if (data.workflows.length > 0) {
				this.$store.commit('activeAlert', {
					message: 'A notificação "' + data.nome + '" não pode ser excluída pois está em uso e vinculada a um ou mais fluxos.',
					status: 'error',
				});
				return;
			}
			this.showAlert = true;
			this.excludeData = data;
		},

		async deleteNotification (notification) {
			this.isLoadingAction = true;
			this.$analytics.resourceManaged('Notificações', 'Deletar');

			await this.restApi().deleteNotificationById(notification.id).then(() => {
				this.$store.commit('activeAlert', {
					message: 'A notificação "' + notification.nome + '" foi excluída com sucesso' ,
					status: 'success',
				});

				this.getNotificationsList();
			}).catch((error) => {
				this.$store.commit('activeAlert', {
					message: error.notifications[0],
					status: 'error',
				});
			});
			
			this.showAlert = false

			this.isLoadingAction = false;

		},

		pagination() {
			this.page++;
			const payload = { ...this.$route.query, size: this.pageSize, page: this.page };
			this.restApi().getNotifications(payload).then((response) => {
				for (const index in response) {
					this.dataTable.push(response[index]);
				}

				if (response.length < 10) {
					this.scrollInfinite = false;
				}
			});
		},

		async initPageNotifications() {
			this.isLoadingPage = true;

			if(Object.keys(this.$route.query).length) {
				this.filterTable();
			} else {
				await this.getNotificationsList();
			}
			this.isLoadingPage = false;
		},

		async getNotificationsList() {
			const payload = { size: this.pageSize, page: 1 };
            
			await this.restApi().getNotifications(payload).then((response) => {
				this.dataTable = response;
				if (response.length < 10) {
					this.scrollInfinite = false;
				}
			});
		},
	},
	watch: {
		isCollapsed(newValue) {
			this.updateNumCells();
		},
	},
	beforeDestroy() {
		this.$root.$off("reloadList");
		window.removeEventListener('resize', this.updateNumCells);
	},
});
